<template lang="pug">
    vm-prompt(@vm-cancel="close" @vm-accept="printCustomerSalesAction" @vm-close="close" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-active="isModalCustomerSalesVisible" :vm-is-valid="!$v.form.$invalid" :vm-title='title')
      vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
        vm-col(vm-justify="center", vm-align="center", vm-w=12)
          b-form-group
            vm-tabs
              vm-tab(vm-label='PDF' @click="changeFormatPdf")
              vm-tab(vm-label='EXCEL' @click="changeFormatExcel")
        vm-col(vm-justify="center", vm-align="center", vm-lg=12)
          b-form-group
            vm-select(url="customers" column="tradename" :placeholder="$t('strings.customer')" autocomplete :label="$t('sales.customer_id')" v-model="form.customer_id" @input-change="autoCompleteFunc")
              vm-select-item(:key="index" :value="item.id" :text="item.tradename" v-for="(item,index) in salesCatalog.customers")
</template>

<script>
import { required } from 'vuelidate/lib/validators' // Ver documentacion
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Sales')

export default {
  name: 'ModalCustomerSales',
  props: {
    title: {
      type: String,
      default: 'Imprimir Ventas por comprador'
    }
  },
  data: () => ({
    form: {
      format: 'pdf'
    }
  }),
  validations: {
    form: {
      customer_id: {
        required
      }
    }
  },
  computed: {
    ...mapGetters([
      'isModalCustomerSalesVisible',
      'salesCatalog'
    ])
  },
  watch: {
  },
  methods: {
    ...mapActions([
      'printCustomerSales',
      'setModalCustomerSalesVisible',
      'loadCatalog'
    ]),
    printCustomerSalesAction () {
      this.printCustomerSales({ form: this.form })
      this.form = {}
      this.setModalCustomerSalesVisible(false)
    },
    close () {
      this.form = {}
      this.setModalCustomerSalesVisible(false)
    },
    changeFormatPdf () {
      this.form.format = 'pdf'
    },
    changeFormatExcel () {
      this.form.format = 'csv'
    },
    autoCompleteFunc (value) {
      let payload = {}
      let column = value.target.parentElement.parentElement.getAttribute('column')
      let param = value.srcElement.value
      payload.url = value.target.parentElement.parentElement.getAttribute('url')
      payload.filter = `?${column}=*${param}*&order_by=${column},asc`
      this.loadCatalog(payload)
    }
  }
}
</script>

  <style lang="scss">
  .vm-select--options {
    z-index: 400331 !important;
  }
  a {
    cursor: pointer;
  }
  .ddrop {
    height: 15vh;
    width: 100%;
    border: dashed 1px;
    border-radius: 10px;
    padding: 5px;
    align-items: center;
    display: flex;
    justify-content: center;
    flex-direction: column;
    ul {
      list-style-type: none;
    }
  }
  .hide {
    display: none;
  }
  </style>
